import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import axios from '../api/axios';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalAdmins: 0,
    totalMessages: 0,
    onlineUsers: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get('/admin/stats');
        setStats(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching stats:', error);
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const StatCard = ({ emoji, label, value, colorHex }) => (
    <div className="glass-panel animate-in" style={{ padding: '24px', position: 'relative', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute',
        top: -30, right: -30,
        width: 100, height: 100,
        background: colorHex,
        opacity: 0.1,
        borderRadius: '50%',
        filter: 'blur(20px)'
      }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div style={{ 
          width: 48, height: 48, borderRadius: 12, 
          background: `rgba(${parseInt(colorHex.slice(1,3), 16)}, ${parseInt(colorHex.slice(3,5), 16)}, ${parseInt(colorHex.slice(5,7), 16)}, 0.15)`,
          border: `1px solid rgba(${parseInt(colorHex.slice(1,3), 16)}, ${parseInt(colorHex.slice(3,5), 16)}, ${parseInt(colorHex.slice(5,7), 16)}, 0.3)`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 
        }}>
          {emoji}
        </div>
        <div style={{ 
          width: 8, height: 8, borderRadius: '50%', backgroundColor: colorHex,
          boxShadow: `0 0 10px ${colorHex}`
        }} />
      </div>
      <div>
        <p style={{ color: 'var(--text-muted)', fontSize: '14px', margin: '0 0 8px 0', fontWeight: '500', textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {label}
        </p>
        <h2 style={{ color: '#fff', fontSize: '36px', margin: 0, fontWeight: '800', letterSpacing: '-0.02em' }}>
          {value.toLocaleString()}
        </h2>
      </div>
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="page-wrapper">
        <div className="header-row">
          <div>
            <h1 className="page-title">Dashboard Overview</h1>
            <p className="page-subtitle">Real-time metrics and statistics for your platform.</p>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px', color: 'var(--text-muted)' }}>
            <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.1)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }}></div>
            <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
            Loading statistics...
          </div>
        ) : (
          <div className="grid-cards">
            <StatCard emoji="👥" label="Total Users" value={stats.totalUsers} colorHex="#3b82f6" />
            <StatCard emoji="🛡️" label="Total Admins" value={stats.totalAdmins} colorHex="#8b5cf6" />
            <StatCard emoji="🟢" label="Online Now" value={stats.onlineUsers} colorHex="#10b981" />
            <StatCard emoji="💬" label="Total Messages" value={stats.totalMessages} colorHex="#f59e0b" />
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
